export const getConfigData = async () => {
    try {
        const res = await fetch("/root/getConfig");
        if (!res.ok) {
            throw new Error(`HTTP error: ${res.status}`);
        }
        const data = await res.json();
        return data;
    } catch (err) {
        console.error("Error loading config:", err);
        return {};
    }
};

export const getCookie = (name) => {
    const cookies = document.cookie.split(";");

    for (let item of cookies) {
        const [key, value] = item.trim().split("=");
        if (key === name) {
            const decoded = decodeURIComponent(value);
            if (decoded === "true") return true;
            if (decoded === "false") return false;
            return decoded;
        }
    }
    return undefined;
};

export const setCookie = (name, value, expirationMinutes) => {
    const date = new Date();
    date.setTime(date.getTime() + (expirationMinutes || 30) * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
}

export const refreshAuthCookies = (expirationMinutes) => {
    const token = getCookie("user_token");
    if (!token) return;
    setCookie("user_token", token, expirationMinutes);
    setCookie("user_email", getCookie("user_email"), expirationMinutes);
    setCookie("pas", getCookie("pas"), expirationMinutes);
};
